module.exports = __webpack_public_path__ + "img/arrowCurrentColor.f8282cf6.svg";